import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const Branch = MatxLoadable({
    loader: () =>
        import ("./New")
})

const Routes = [{
    path: "/datasetup/message",
    component: Branch,
    auth: authRoles.Message_Setting
}];

export default Routes;